import React, { Component } from 'react';

import { observer } from 'mobx-react';

import GetAgreementInfoApi from "../../../util/api/ServiceObjects/GetAgreementInfoApi";

import { Route, Switch, useLocation } from 'react-router-dom'


let AgreementInfoWidget = ({ ...props }) => {
    const { pathname, hash, key } = useLocation();
    const [agreementInfo, setAgreementInfo] = React.useState(null);


    React.useEffect(() => {
        GetAgreementInfoApi.get(props.timesheetId)
            .then(data => {
                setAgreementInfo(data)
            })
    }, [props.timesheetId]);

    function getBootstrapClass(status) {
        if (status == "OUT_FOR_SIGNATURE") {
            return "warning"
        }
        else if (status == "CANCELLED") {
            return "danger"
        }
        return "success"
    }

    function resubmitTimesheet() {
        setAgreementInfo(null)
        GetAgreementInfoApi.put(props.timesheetId)
            .then(data => {
                setAgreementInfo(data)
            })
        }
    

    

    if (agreementInfo == null) {
        return (
            <div className={"p-3 m-3 alert"}>
                <h2>Agreement Info</h2>
                <p>Agreement info loading...</p>
            </div>
        )
    }
    else if (agreementInfo.error == null) {
        let bootstrapClass = getBootstrapClass(agreementInfo.status)
        return (
            <div className={"p-3 m-3 alert-" + bootstrapClass}>
                <h2>Agreement Info</h2>
                <p>Status: <span> {agreementInfo.status}</span></p>
                <p>Student Email: <span>{agreementInfo.studentEmail}</span></p>
                <p>Supervisor Email: <span>{agreementInfo.supervisorEmail}</span></p>
                <div class="d-flex flex-row justify-content-around">
                    <a class="btn btn-secondary" target="_blank" href={agreementInfo.adobeLink}>View</a>
                    <a class="btn btn-secondary" target="_blank" href={agreementInfo.downloadLink}>Download</a>
                </div>
                <div class="d-flex flex-row justify-content-around">
                    <a class="btn btn-primary" onClick={resubmitTimesheet}>Cancel & Resubmit to Adobe Sign</a>
                </div>
            </div>)
    }
    else {
        return (
            <div className={"p-3 m-3 alert-error"}>
                <h2>Agreement Info</h2>
                <p><b>Alert:</b> {agreementInfo.error}</p>
            </div>
        )
    }
}

export default observer(AgreementInfoWidget);

    
